<template>
  <main>
    <!-- Hero Banner -->
    <lazy-cms-section v-if="espots?.[0]" :section="espots[0]" />
    <!-- Sticky Navigation -->
    <nav v-style:top="{ sm: '3.75rem', md: '4rem' }" class="sticky z-header b-b b-grey-50 bg-white">
      <ul class="flex gap-8 overflow-auto px-6 py-4 align-middle scrollbar-none lg:justify-start" role="list">
        <li v-for="({ label, to }, key) in $feature.storiesStickyNav" :key class="shrink-0" role="listitem">
          <base-button
            :aria-current="key === navIndex ? 'page' : undefined"
            :aria-label="label"
            class="title-3"
            :class="{ 'c-brand-4': key === navIndex }"
            @click="scrollToElement(to, { offset: offsetTop })"
          >
            {{ label }}
          </base-button>
        </li>
      </ul>
    </nav>
    <!-- Custom Article Carousel, displays the latest five articles sorted by creatingDate -->
    <section class="px-4 md:px-6">
      <h2 class="pb-6 pt-12 title-1">
        {{ $t.latestForVans }}
      </h2>
      <vf-carousel-elevate class-container="gap-x-2" class-controls="bg-black c-white" :drag-free="false">
        <base-link
          v-for="({ picture, title, description, date, url, eyebrow }, key) in articles?.result"
          :key
          class="w-4/5 md:w-2/3 md:flex"
          :to="url"
        >
          <cms-picture class="aspect-square md:w-1/2" :content="picture as CMSPicture" fit="cover" />
          <div class="p-4 md:w-1/2 md:f-col space-y-4 md:between">
            <div class="space-y-4">
              <h4 class="title-4 c-brand-4">
                {{ eyebrow }}
              </h4>
              <h3 class="title-3">
                {{ title }}
              </h3>
              <p>{{ description }}</p>
            </div>
            <div class="pb-2 text-sm space-y-3">
              <p>{{ dateFormat(date, 'YYYY-MM-DD', 'DD/MM/YYYY') }}</p>
              <p class="text-sm fw-bold underlined">
                {{ $t.readFullArticle }}
              </p>
            </div>
          </div>
        </base-link>
      </vf-carousel-elevate>
    </section>
    <!-- Empty Espot (Brand will use it in the future) -->
    <lazy-cms-section v-if="espots?.[1]" :section="espots[1]" />
    <!-- Article Grids -->
    <template v-for="({ to }, key) in $feature.storiesStickyNav" :key>
      <base-sticky :data-scroll-el="to" :margin="offsetTop" :name="to">
        <lazy-cms-section
          v-if="espots?.[2 + key]"
          :data-scroll-el="to"
          :section="espots[2 + key]"
        />
      </base-sticky>
    </template>
  </main>
</template>

<script lang="ts" setup>
import type { CMSPicture } from '#types/media'

const { $t, $feature } = useNuxtApp()
const sticky = useSticky()
const offsetTop = 115

const articles = await useCms().getSearch('article', { limit: 5, sortBy: 'creationdate_desc' }).catch((err) => {
  log.error('Error fetching articles:', err)
  return { result: [] }
})

const espots = (await useCms().getSections.generic('vans-stories').catch((err) => {
  log.error('Error fetching CMS sections:', err)
  return { data: { value: { content: { sections: [] } } } }
})).data.value?.content.sections || []

const navIndex = computed(() => Object.values(sticky.value).filter((el) => el !== null).length - 1)
</script>
